"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultComponent = ResultComponent;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const DateHelper = __importStar(require("@genesys/shared/lib/date-helper"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const searchQueryGQL = (0, graphql_tag_1.default) `
  query TandCAcceptanceStatusResultQuery($filter: TandCFilterInputType!) {
    user {
      tAndCAcceptanceStatus(filter: $filter) {
        userId
        userName
        fullName
        date
        acceptedStatus
        firstLogin
        lastLogin
      }
    }
  }
`;
function ResultComponent(props) {
    const context = React.useContext(Contexts.UserProfileContext);
    const { locale } = context;
    return (React.createElement(GraphQLQuery.QueryUserSimple, { variables: {
            filter: {
                acceptanceStatusFilter: {
                    selectedStatus: props.searchSelections.acceptanceStatusItemState.selectedStatus
                },
                userItemFilter: {
                    selectedUser: props.searchSelections.userItemState.selectedUser.trim()
                }
            }
        }, query: searchQueryGQL }, result => {
        const resultRows = mapResultToResultRow(result, locale);
        return (React.createElement("div", null,
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(Exporter.XlsxSingleSheetExport, { data: resultToFile(resultRows), filename: "t-and-c-acceptance-status" }, onClick => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download")))),
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(ResultTable, Object.assign({ resultRows: resultRows }, props)),
                ";")));
    }));
}
function mapResultToResultRow(result, locale) {
    return result.user.tAndCAcceptanceStatus.map(x => ({
        userId: x.userId,
        userName: x.userName,
        fullName: x.fullName,
        firstLogin: x.firstLogin
            ? DateHelper.getDateString(DateHelper.fromUTC(x.firstLogin), locale)
            : "",
        lastLogin: x.lastLogin
            ? DateHelper.getDateString(DateHelper.fromUTC(x.lastLogin), locale)
            : "",
        date: x.date || "",
        acceptedStatus: x.acceptedStatus
    }));
}
function ResultTable(props) {
    return (React.createElement("div", null,
        React.createElement(Elements.DataPresenterTable, null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "UserName"),
                    React.createElement("th", null, "FullName"),
                    React.createElement("th", null, "FirstLogin"),
                    React.createElement("th", null, "LastLogin"),
                    React.createElement("th", null, "AcceptedStatus"),
                    React.createElement("th", null, "Date"))),
            React.createElement("tbody", null, props.resultRows.map(x => (React.createElement("tr", null,
                React.createElement("td", null, x.userName),
                React.createElement("td", null, x.fullName),
                React.createElement("td", null, x.firstLogin),
                React.createElement("td", null, x.lastLogin),
                React.createElement("td", null, x.acceptedStatus),
                React.createElement("td", null, x.date))))))));
}
function resultToFile(results) {
    return [
        [
            "UserName",
            "FullName",
            "FirstLogin",
            "LastLogin",
            "AcceptedStatus",
            "Date"
        ]
    ].concat(results.map(r => {
        var _a;
        return [
            r.userName,
            r.fullName,
            r.firstLogin,
            r.lastLogin,
            r.acceptedStatus,
            (_a = r.date) !== null && _a !== void 0 ? _a : ""
        ];
    }));
}
//# sourceMappingURL=result-component.js.map